
import { defineComponent, computed, PropType } from "vue";
import { OrcamentoPayload } from "../../modules/business/orcamento/orcamentoBusiness";

export default defineComponent({
  setup(props, { emit }) {
    const getTituloTransportador = () => {
      const o = props.orcamento;
      if (o.nomeTransportador) {
        return o.nomeTransportador;
      }
      return o.idTransportador
        ? `Transportador #${o.idTransportador}`
        : "Sem transportador";
    };

    const qtdItensLabel = computed(() => {
      const n = props.orcamento.qtdItens ?? props.orcamento.itens?.length ?? 0;
      return n === 1 ? "1 item" : `${n} itens`;
    });

    const formatMoney = (valor?: number | null) => {
      if (valor === null || valor === undefined) return "R$ 0,00";
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    };

    const diasDesdeEnvio = computed<number | null>(() => {
      const dataEnvio = props.orcamento.dataEnvio;
      if (!dataEnvio) return null;
      const d = typeof dataEnvio === "string" ? new Date(dataEnvio) : dataEnvio;
      const diff = Date.now() - d.getTime();
      return Math.floor(diff / (1000 * 60 * 60 * 24));
    });

    const onClick = () => {
      emit("click-orcamento", props.orcamento);
    };

    return {
      getTituloTransportador,
      qtdItensLabel,
      formatMoney,
      diasDesdeEnvio,
      onClick
    };
  },
  props: {
    orcamento: {
      type: Object as PropType<OrcamentoPayload>,
      required: true
    }
  }
});
